// Home BreakPoint Product Swiper
export const HomeProductSwiperBreakPoints = {
  320: {
    spaceBetween: 4,
    slidesPerView: 2.1,
  },
  641: {
    spaceBetween: 4,
    slidesPerView: 3,
  },
  769: {
    slidesPerView: 4.5,
  },
};

// Category BreakPoint Product Swiper
export const CategoryProductSwiperBreakPoints = {
  320: {
    spaceBetween: 4,
    slidesPerView: 2.1,
  },
  641: {
    spaceBetween: 4,
    slidesPerView: 3,
  },
  769: {
    slidesPerView: 4.5,
  },
};

export const BrandHomeBreakPoints = {
  320: {
    slidesPerView: 2.5,
  },
  571: {
    slidesPerView: 3.5,
  },
  769: {
    slidesPerView: 5,
  },
  991: {
    slidesPerView: 6,
  },
};

export const BrandCategoryBreakPoints = {
  320: { slidesPerView: 3 },
  511: { slidesPerView: 3 },
  641: { slidesPerView: 3.5 },
  991: { slidesPerView: 4 },
  1440: { slidesPerView: 5.5 },
};
